import { Home } from './components/Home';                                       /*Ȩ*/
import { NoAuthencation } from './components/NoAuthencation';                   /*���Ѿ���*/

import { Index as LoginMgr } from './components/Account/LoginMgr/Index';        /*�α���*/
import { Index as MemberMgr } from './components/Account/MemberMgr/Index';      /*ȸ������*/
import { Index as Notice } from './components/MyPage/Notice/Index';             /*��������*/
import { Index as GoodsMgr } from './components/Goods/GoodsMgr/Index';          /*��ǰ����Ʈ*/
import { Index as RegisterMgr } from './components/Goods/RegisterMgr/Index';    /*��ǰ���*/
import { Index as MyRetail } from './components/Retail/MyRetail/Index';         /*�ŷ�ó����*/
import { Index as RetailMgr } from './components/Retail/RetailMgr/Index';       /*�ŷ�ó ���ο�û*/
import { Index as MyInfoMgr } from './components/MyPage/MyInfoMgr/Index';       /*����������*/
import { Index as OrderMgr } from './components/Order/OrderMgr/Index';          /*�ֹ�����*/
import { Index as QuestionMgr } from './components/Order/QuestionMgr/Index';    /*�ֹ�����*/

import { LiveChatList } from './components/Order/LiveChat/LiveChatList';        /*ä�ø���Ʈ*/
import { Index as LiveChat } from './components/Order/LiveChat/Index';          /*ä�ù�*/

import { Creator } from './components/AIStudio/Creator';              /*AI Studio*/
import { AIFittingMgr } from './components/AIStudio/AIFittingMgr';              /*AI Studio*/



const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/NoAuthencation',
        element: <NoAuthencation />
    },
    {
        path: '/Account/LoginMgr/Index',
        element: <LoginMgr />
    },
    {
        path: '/Account/MemberMgr/Index',
        element: <MemberMgr />
    },
    {
        path: '/MyPage/Notice/Index',
        element: <Notice />
    },
    {
        path: '/Goods/GoodsMgr/Index',
        element: <GoodsMgr />
    },
    {
        path: '/Goods/RegisterMgr/Index',
        element: <RegisterMgr />
    },
    {
        path: '/Retail/MyRetail/Index',
        element: <MyRetail />
    },
    {
        path: '/Retail/RetailMgr/Index',
        element: <RetailMgr />
    },
    {
        path: '/MyPage/MyInfoMgr/Index',
        element: <MyInfoMgr />
    },
    {
        path: '/Order/OrderMgr/Index',
        element: <OrderMgr />
    },
    {
        path: '/Order/QuestionMgr/Index',
        element: <QuestionMgr />
    },
    {
        path: '/Order/LiveChat/LiveChatList',
        element: <LiveChatList />
    },
    {
        path: '/Order/LiveChat/Index',
        element: <LiveChat />
    },
    {
        path: '/AIStudio/Creator',
        element: <Creator />
    },
    {
        path: '/AIStudio/AIFittingMgr',
        element: <AIFittingMgr />
    },
];

export default AppRoutes;
